/* Buscador por patente en la HOME, como PESTAÑA colgando del banner.
 *
 * Concepto (JP 2026-07-28): cada banner de la home es un "cajon" de una categoria — el banner
 * lleva la imagen y justo debajo asoma una pestañita donde el cliente pone su patente. Hoy solo
 * esta frenos; la idea es repetirlo con bujias, etc. Por eso la definicion vive en CATEGORIAS y
 * agregar una nueva es sumar una entrada, no reescribir el widget.
 *
 * CAMBIO (JP 2026-07-29): la pestaña YA NO pinta resultados inline sobre el home (eso desordenaba
 * la navegacion). Ahora solo valida la patente y navega a la vista #frenos/PATENTE del SPA
 * (allure-tecdoc.js), que muestra las opciones como cualquier pagina del sitio: breadcrumb +
 * listado vertical estilo ML. Este asset queda como un simple formulario de entrada.
 */
(function () {
  var app = document.getElementById('allure-app');
  if (!app) return;
  var API = (app.dataset.apiUrl || '').replace(/\/+$/, '');
  if (!API) return;

  // Para sumar una categoria nueva: agregar aqui su entrada (hash = vista del SPA que la atiende).
  var CATEGORIAS = [
    { id: 'frenos', hash: '#frenos/', texto: 'Pon tu patente y mira los frenos para tu auto', boton: 'Ver mis frenos' }
  ];

  var CSS = '' +
    /* Banner +20% de alto (JP 2026-07-28): 120px -> 144px. Se sube desde aqui con mayor
       especificidad (#allure-app .al-banner) en vez de editar allure-tecdoc.css. */
    '#allure-app .al-banner{min-height:144px}' +
    /* la pestaña se pega al banner: sin margen arriba y esquinas solo abajo */
    '.alfr-tab{margin:-1px 0 26px;border:1px solid #e1e4e8;border-top:0;border-radius:0 0 12px 12px;' +
      'background:#fff;overflow:hidden}' +
    '.alfr-bar{display:flex;align-items:center;gap:10px;flex-wrap:wrap;padding:10px 14px;' +
      'background:linear-gradient(180deg,#fbfbfc,#f4f6f8)}' +
    '.alfr-txt{font-size:12.5px;color:#444;font-weight:600;flex:1 1 200px;min-width:0}' +
    '.alfr-f{display:flex;gap:7px;flex:0 1 auto}' +
    '.alfr-i{width:128px;padding:8px 10px;font-size:13px;font-weight:700;letter-spacing:.09em;' +
      'text-transform:uppercase;border:2px solid #dcdfe3;border-radius:7px;background:#fff}' +
    '.alfr-i:focus{outline:0;border-color:#c62828;box-shadow:0 0 0 3px rgba(198,40,40,.12)}' +
    '.alfr-b{padding:8px 15px;font-size:12px;font-weight:700;color:#fff;background:#c62828;' +
      'border:0;border-radius:7px;cursor:pointer;white-space:nowrap}' +
    '.alfr-b:hover{background:#a91d1d}' +
    '.alfr-msg{display:none;padding:0 14px 10px;font-size:12.5px;color:#c62828;font-weight:600}' +
    '.alfr-msg.on{display:block}' +
    '@media(max-width:600px){.alfr-i{width:100%}.alfr-f{flex:1 1 100%}.alfr-b{flex:1}}';

  var styleOk = false;
  function css() {
    if (styleOk) return;
    var st = document.createElement('style'); st.textContent = CSS;
    document.head.appendChild(st); styleOk = true;
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }

  function pestaña(cat) {
    var d = document.createElement('div');
    d.className = 'alfr-tab'; d.dataset.cat = cat.id;
    d.innerHTML =
      '<div class="alfr-bar">' +
        '<span class="alfr-txt">' + esc(cat.texto) + '</span>' +
        '<form class="alfr-f"><input class="alfr-i" type="text" maxlength="20" required ' +
          'placeholder="BCDF12" aria-label="Patente o número de chasis">' +
          '<button class="alfr-b" type="submit">' + esc(cat.boton) + '</button></form>' +
      '</div>' +
      '<div class="alfr-msg"></div>';

    var form = d.querySelector('form'), input = d.querySelector('.alfr-i'),
        msg = d.querySelector('.alfr-msg');

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var q = (input.value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (q.length < 4) { msg.textContent = 'Escribe una patente válida.'; msg.classList.add('on'); return; }
      msg.classList.remove('on');
      // Navegación normal del sitio: la vista #frenos/ del SPA hace la búsqueda y pinta la página.
      location.hash = cat.hash + encodeURIComponent(q);
    });
    return d;
  }

  function insertar() {
    var h = (location.hash || '#home').slice(1).split('/')[0];
    if (h && h !== 'home') return;
    var banner = app.querySelector('.al-banner');
    if (!banner) return;
    css();
    CATEGORIAS.forEach(function (cat) {
      if (app.querySelector('.alfr-tab[data-cat="' + cat.id + '"]')) return;
      banner.parentNode.insertBefore(pestaña(cat), banner.nextSibling);
    });
  }

  // allure-tecdoc.js pinta async y repinta al cambiar de vista: se observa en vez de esperar.
  new MutationObserver(insertar).observe(app, { childList: true, subtree: true });
  insertar();
})();
